import { SET_DEFAULT_CONFIGS } from '../../constants/ActionConstants';

export const setDefaultConfigs = (defaultConfigs) => ({
    type: SET_DEFAULT_CONFIGS,
    data: { defaultConfigs: defaultConfigs }
});